import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MasterMappingsEditComponent } from './master-mappings-edit/master-mappings-edit.component';
import { MasterMappingsBrowseComponent } from './master-mappings-browse/master-mappings-browse.component';
import { AuthGuard } from '../shared/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'maintenance',
        component: MasterMappingsBrowseComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'maintenance/edit',
        component: MasterMappingsEditComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'maintenance/edit/:id',
        component: MasterMappingsEditComponent,
        canActivate: [AuthGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MasterMappingsRoutingModule { }
